import { useState } from 'react';
import { useAppForm } from 'shared/UI/UIKit/Form';
import { useCreateMaxLessonsPerDayMutation, type MaxLessonsPerDay } from 'shared/api';
import { maxLessonsPerDayCreateConfig } from './config';

interface UseMaxLessonsPerDayCreateProps {
  refreshTable: () => void;
}

export const useMaxLessonsPerDayCreate = ({ refreshTable }: UseMaxLessonsPerDayCreateProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = useAppForm<MaxLessonsPerDay>();
  const [createMaxLessonsPerDay] = useCreateMaxLessonsPerDayMutation();

  const showModal = () => {
    setModalVisible(true);
    form.setFieldsValue(maxLessonsPerDayCreateConfig);
  };

  const hideModal = () => {
    setModalVisible(false);
    form.resetFields();
  };

  const onSubmit = async () => {
    await form.validateFields().then(async (values) => {
      await createMaxLessonsPerDay(values)
        .unwrap()
        .then(() => {
          hideModal();
          refreshTable();
        });
    });
  };

  return {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  };
};
